module.exports = {"id":"226075","name":"Michalis Bakakis","rating":"72","photo":"./data/images/photos/1/226075.png","club":{"name":"AEK Athènes","logo":"./data/images/clubs/AEKAthenes.png"},"positions":["DD","DG","DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichalisBakakis0.json
// module id = 2994
// module chunks = 0